import axios from 'axios';
import Cookies from 'js-cookie';

const instance = axios.create({
  baseURL: process.env.VUE_APP_BASE_URL,
  // baseURL: "https://dev-be.lugu.id",
  withCredentials: true,
});

instance.interceptors.response.use(
  (res) => res,
  (error) => {
    if (error.status == 401) {
      location.href = '/login';
    }
    return Promise.reject(error);
  }
);

instance.interceptors.request.use(
  (config) => {
    config.headers.setAuthorization(`Bearer ${Cookies.get('token')}`);
    return config;
  },
  (error) => Promise.reject(error)
);

export default instance;
